"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderSubtitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const typography_1 = require("@alfalab/core-components/typography");
const hooks_1 = require("@alfalab/hooks");
const component_context_1 = require("../../../context/component.context");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * @private
 */
const HeaderSubtitle = ({ children }) => {
    const { isMobile, isResponsive } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    const [mediaMobile] = (0, hooks_1.useMedia)([[true, '(max-width: 1023px)']], false);
    let compact = false;
    if (isResponsive) {
        compact = mediaMobile;
    }
    else {
        compact = isMobile;
    }
    return ((0, jsx_runtime_1.jsx)(typography_1.Typography.Text, { tag: 'div', view: compact ? 'component' : 'primary-medium', color: 'secondary', className: index_module_css_1.default.subtitle, dataTestId: 'subtitle', rowLimit: 2, children: children }));
};
exports.HeaderSubtitle = HeaderSubtitle;
